<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { imask } from "svelte-imask";
  import Tooltip from "@shared/svelte/Components/Tooltip.svelte";
  import type { FormField } from "@shared/types/Form";

  export let classes: string = "fizz-full-width fizz-flow-4 fizz-stack-16 fizz-inline-block";
  export let name: string = "phone";
  export let id: string = name;
  export let field: FormField;
  export let label: string = "Phone";
  export let labelClasses: string = "fizz-stack-8";
  export let placeholder = "";
  export let testid: string = id;
  export let tooltip = "";

  const options = { mask: "(000) 000-0000" };

  const dispatch = createEventDispatcher();

  const onAccept = ({ detail: imask }) => dispatch("accept", imask);

  const onComplete = ({ detail: imask }) => dispatch("completed", imask);

  const onBlur = (e: FocusEvent): void => {
    dispatch("blur", { target: e.currentTarget, field, fieldValue: $field });
  };

  const onChange = (e: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
    dispatch("change", { target: e.currentTarget, field, fieldValue: $field });
  };

  const onFocus = (e: FocusEvent): void => {
    dispatch("click", { target: e.currentTarget, field, fieldValue: $field });
  };

</script>

<label class={classes} for={id}>
  <p class="fizz-label fizz-flex-row-4 {labelClasses}">
    <strong>{label}</strong>
    {#if tooltip}
      <Tooltip text={tooltip} />
    {/if}
  </p>
  <input
    {name}
    {id}
    {placeholder}
    class="fizz-input-text fizz-full-width"
    class:fizz-input-error={!$field.valid}
    data-testId={testid}
    type="tel"
    use:imask={options}
    bind:value={$field.value}
    on:accept={onAccept}
    on:blur={onBlur}
    on:change={onChange}
    on:complete={onComplete}
    on:focus={onFocus}
  />
  <slot />
</label>
